import { serverTimestamp } from 'firebase/firestore';
import {
  LEGAL_PRIVACY_VERSION,
  LEGAL_TERMS_VERSION,
} from '@/legal/legalDocumentVersions';

/** Поля для merge в `users/{uid}` при принятии условий при регистрации. */
export function legalConsentFirestorePatch(): {
  acceptedTermsVersion: string;
  acceptedPrivacyVersion: string;
  acceptedAt: ReturnType<typeof serverTimestamp>;
} {
  return {
    acceptedTermsVersion: LEGAL_TERMS_VERSION,
    acceptedPrivacyVersion: LEGAL_PRIVACY_VERSION,
    acceptedAt: serverTimestamp(),
  };
}
